import { useCallback } from 'react';

import { Skeleton, Spin, Tag } from 'antd';
import { useGetUnifiedRelationsInfiniteInfiniteQuery } from 'services';
import { useInfiniteScroll } from 'hooks';

import RelationItem from './relation-item';
import EmptyState from './empty-state';

/**
 * @param {Object} props
 * @param {string} props.baseType - Encyclopedia type of the base article.
 * @param {number|string} props.baseId - ID of the base article.
 */
function IndirectRelations({ baseType, baseId }) {
  const { data, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useGetUnifiedRelationsInfiniteInfiniteQuery({ baseType, baseId, direction: 'indirect' });

  const pages = data?.pages ?? [];
  const relations = pages.flatMap((page) => page['hydra:member']);
  const totalItems = pages[0]?.['hydra:totalItems'] ?? relations.length;

  const handleReachEnd = useCallback(() => {
    fetchNextPage();
  }, [fetchNextPage]);

  const { ref } = useInfiniteScroll({
    onReachEnd: handleReachEnd,
    disabled: !hasNextPage || isFetchingNextPage,
  });

  if (isLoading) {
    return <Skeleton active />;
  }

  return (
    <div>
      <Tag color="orange" style={{ marginBottom: 12 }}>
        Dolaylı İlişkiler ({totalItems})
      </Tag>
      <div style={{ maxHeight: 600, overflowY: 'auto' }}>
        {relations.length > 0 ? (
          relations.map((relation, index) => (
            <RelationItem
              key={relation?.id ?? index}
              ref={index === relations.length - 1 ? ref : undefined}
              relation={relation}
            />
          ))
        ) : (
          <EmptyState message="Dolaylı ilişki yok" />
        )}
        {isFetchingNextPage && (
          <div style={{ textAlign: 'center', padding: 12 }}>
            <Spin size="small" />
          </div>
        )}
      </div>
    </div>
  );
}

export default IndirectRelations;
